import { InvestmentAccountClosureReason } from 'generated/types'

export const EarlyClosureReasonScreenViewed = {
  screen: 'earlyReasonForClosing',
  screen_name: 'earlyReasonForClosing',
  object_name: 'earlyReasonForClosing',
  Feature: 'closeEarly',
}

export const EarlyClosureContinueTapped = (
  reason: InvestmentAccountClosureReason,
) => ({
  object_name: 'earlyNextCTATapped',
  screen: 'earlyReasonForClosing',
  screen_name: 'earlyReasonForClosing',
  reason: `${reason}`,
})

export const EarlyCancelCTATapped = {
  object_name: 'earlyNextCancelTapped',
  screen: 'earlyReasonForClosing',
  screen_name: 'earlyReasonForClosing',
}

export const EarlyCloseAccountsCTATapped = {
  object_name: 'earlyCloseAccount(s)CTATapped',
  screen: 'earlyCloseAccount',
  screen_name: 'earlyCloseAccount',
}

export const EarlyCloseConfirmationModal = {
  screen: 'earlyCloseAccount',
  screen_name: 'earlyCloseAccount',
  object_name: 'earlyCloseAccountsAreYouSureModal',
}

export const EarlyCloseConfirmationModalNevermindCTA = {
  screen: 'earlyCloseAccount',
  screen_name: 'earlyCloseAccount',
  object_name: 'earlyNevermindCTATapped',
}

export const EarlyCloseConfirmationModalConfirmCTA = {
  screen: 'earlyCloseAccount',
  screen_name: 'earlyCloseAccount',
  object_name: "earlyI'mSureCTATapped",
}

export const EarlyClosureInProgress = {
  object_name: 'earlyClosureInProgress',
  screen_name: 'earlyClosureInProgress',
  screen: 'earlyClosureInProgress',
}

export const EarlyClosureComplete = {
  object_name: 'earlyClosureComplete',
  screen_name: 'earlyClosureComplete',
  screen: 'earlyClosureComplete',
}
